<template>
  <appointment-historical
    main-page-title="Manejo de Citas"
    :main-page-routes="['Inicio', 'Estudiante', 'Citas', 'Historial de Citas']"
    :get-appointment-history="getAppointmentHistory"
  />
</template>

<script>
import { AppointmentHistorical } from 'appointment-management';
import appointmentServices from '@/services/api/appointment.api.js';

export default {
  name: 'AppointmentHistoricalWrapper',
  components: {
    AppointmentHistorical,
  },
  methods: {
    getAppointmentHistory(clientAppointmentId) {
      return appointmentServices.getAppointmentHistory(clientAppointmentId);
    },
  },
};
</script>
